import React from 'react';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';

export const ACTION_BUTTON_TYPE = {
  ADD_REIMBURSEMENT_ACCOUNT: 'add_reimbursement_account',
  UPLOAD_DOCUMENTS: 'upload_documents',
  BENEFIT_CALCULATION: 'benefit_calculation'
};
const IN_PROGRESS = {
  label: 'In Progress',
  icon: 'hourglass',
  className: 'status_inprogress'
};
const WE_WORKING_ON_IT = {
  label: 'WE’RE WORKING ON IT',
  icon: 'hourglass',
  className: 'status_inprogress'
};

const ON_HOLD_ACTION_REQUIRED = {
  label: 'ON HOLD - ACTION REQUIRED',
  icon: 'warning-triangle',
  className: 'status_warning'
};

const NOT_COVERED = {
  label: 'NOT COVERED',
  icon: 'cross-circle',
  className: 'status_notcovered',
  inlineText: () => (
    <>
      &nbsp;<a href={CSPUrlsMap.myDocuments.url}>My Documents</a>
    </>
  )
};

const COMPLETED_NIL_BENEFIT = {
  label: 'Completed, Nil Benefit',
  icon: 'tick-circle',
  className: 'status_paid',
  inlineText: ({ onClick }) => (
    <span>
      , please refer to your{' '}
      <button
        type="button"
        className="button text_only actionInlineTextButton"
        onClick={() => onClick(ACTION_BUTTON_TYPE.BENEFIT_CALCULATION)}
      >
        benefit calculation
      </button>{' '}
      and <a href={CSPUrlsMap.myDocuments.url}>correspondence.</a>
    </span>
  )
};

const PAID = {
  label: 'Paid',
  icon: 'tick-circle',
  className: 'status_paid',
  inlineText: ({ onClick }) => (
    <span>
      View{' '}
      <button
        type="button"
        className="button text_only actionInlineTextButton"
        onClick={() => onClick(ACTION_BUTTON_TYPE.BENEFIT_CALCULATION)}
      >
        benefit calculation
      </button>{' '}
      and <a href={CSPUrlsMap.myDocuments.url}>correspondence.</a>
    </span>
  )
};

const APPROVED = {
  label: 'Approved',
  icon: 'tick-circle',
  className: 'status_paid',
  inlineText: ({ onClick }) => (
    <span>
      View{' '}
      <button
        type="button"
        className="button text_only actionInlineTextButton"
        onClick={() => onClick(ACTION_BUTTON_TYPE.BENEFIT_CALCULATION)}
      >
        benefit calculation
      </button>{' '}
      and <a href={CSPUrlsMap.myDocuments.url}>correspondence.</a>
    </span>
  )
};

const CLAIM_APPROVED_ACTION_REQUIRED = {
  label: 'CLAIM APPROVED - ACTION REQUIRED',
  icon: 'warning-triangle',
  className: 'status_warning',
  inlineText: ({ onClick, petName }) => (
    <span>
      This claim was approved but we do not have reimbursement bank account details for {petName}, so we are unable to
      pay your claim.{' '}
      <button
        type="button"
        className="button text_only actionInlineTextButton"
        onClick={() => onClick(ACTION_BUTTON_TYPE.ADD_REIMBURSEMENT_ACCOUNT)}
      >
        Update reimbursement details
      </button>
      . View{' '}
      <button
        type="button"
        className="button text_only actionInlineTextButton"
        onClick={() => onClick(ACTION_BUTTON_TYPE.BENEFIT_CALCULATION)}
      >
        benefit calculation
      </button>
      .
    </span>
  ),
  renderActionButton: ({ onClick }) => (
    <button
      type="button"
      onClick={() => onClick(ACTION_BUTTON_TYPE.ADD_REIMBURSEMENT_ACCOUNT)}
      className="button primary actionButton"
    >
      <Icon icon="banking" />
      Add reimbursement account
    </button>
  )
};
export const logicalClaimStatusMap = ({ isUploadAdditionalDocs, statusCode, logicalClaimStatus, benefitPaid }) => {
  switch (statusCode) {
    case '100_IN':
    case '105_CALC':
    case '105A_CALC':
    case '701_PAUTH':
    case '707_AUDIT':
    case '250_HVA':
    case '202_NLODG':
    case '203_NLODG':
    case '700_GOPAUT':
    case '704_GOPAUT':
    case '601_BCNA':
    case '708_HC':
      return IN_PROGRESS;

    case '500_MIO':
    case '500_MD':
      if (isUploadAdditionalDocs) {
        return ON_HOLD_ACTION_REQUIRED;
      }
      if (
        logicalClaimStatus === 'WORKINGONIT' ||
        logicalClaimStatus === 'We’re Working On It' ||
        logicalClaimStatus === 'WE’RE WORKING ON IT'
      ) {
        return WE_WORKING_ON_IT;
      }
      return IN_PROGRESS;

    case '500_LEC':
      if (isUploadAdditionalDocs) {
        return ON_HOLD_ACTION_REQUIRED;
      }
      return WE_WORKING_ON_IT;

    case '500_OH':
    case '500_HR':
      return IN_PROGRESS;

    case '600_NOTAD':
      if (logicalClaimStatus === 'NOTCOVERED') {
        return NOT_COVERED;
      }
      return IN_PROGRESS;

    case '705_PAID':
      if (benefitPaid === 0) {
        return COMPLETED_NIL_BENEFIT;
      }
      return PAID;

    case '702_AUTHOR':
      if (logicalClaimStatus === 'APPROVED') {
        if (benefitPaid === 0) {
          return COMPLETED_NIL_BENEFIT;
        }
        return APPROVED;
      }
      if (logicalClaimStatus === 'INPROGRESS' || logicalClaimStatus === 'In Progress') {
        return IN_PROGRESS;
      }
      return null;

    case '500_BKD':
      return CLAIM_APPROVED_ACTION_REQUIRED;

    default:
      return null;
  }
};
